import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";

export default function ShortRedirectPage() {
  const { code } = useParams();
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get(`/shortlinks/${code}`).then(({ data }) => {
      window.location.replace(data.target_url);
    }).catch(() => setError(true));
  }, [code]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center font-serif text-2xl text-[#10243A]" data-testid="shortlink-not-found">
        Линкът не е намерен
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center text-[#66717B]" data-testid="shortlink-redirecting">
      Пренасочване...
    </div>
  );
}
